import { useCallback } from 'react';
import { SelectedCurrentConditionType } from 'types/searchCondition';
import { SEARCH_TYPE } from 'components/SearchSideBar/constants';
import { moveToSearchResultPage } from '../../../../../../../../components/SearchSideBar/logics/moveToSearchResultPage';

/**
 * 検索処理をまとめたhooks
 * @param selectedSearchCondition 選択されている検索条件
 * @param oldestDayWdtno 保存した検索条件で一番古い検索条件番号
 * @param loginStatus ログイン状態
 * @returns 検索処理
 */
export const useSearch = (
  selectedSearchCondition: SelectedCurrentConditionType,
  oldestDayWdtno: number,
  loginStatus: boolean
) => {
  // サイドバー上での検索処理
  const onClickSearchButton = useCallback(() => {
    return moveToSearchResultPage(
      selectedSearchCondition,
      SEARCH_TYPE.SEARCH_BUTTON,
      loginStatus,
      oldestDayWdtno
    );
  }, [loginStatus, oldestDayWdtno, selectedSearchCondition]);

  // オーバーレイ上での検索処理
  const onClickSearchFloatButton = useCallback(() => {
    moveToSearchResultPage(
      selectedSearchCondition,
      SEARCH_TYPE.SEARCH_BUTTON_FLOAT,
      loginStatus,
      oldestDayWdtno
    );
  }, [loginStatus, oldestDayWdtno, selectedSearchCondition]);

  // 職種モーダルでの検索処理
  const onClickOccupationModalSearchButton = useCallback(
    (selectedOccupation: {
      searchJobTypeLId: SelectedCurrentConditionType['searchJobTypeLId'];
      searchJobTypeMId: SelectedCurrentConditionType['searchJobTypeMId'];
      searchJobTypeSId: SelectedCurrentConditionType['searchJobTypeSId'];
    }) => {
      moveToSearchResultPage(
        { ...selectedSearchCondition, ...selectedOccupation },
        SEARCH_TYPE.OCCUPATION_MODAL,
        loginStatus,
        oldestDayWdtno
      );
    },
    [loginStatus, oldestDayWdtno, selectedSearchCondition]
  );

  // 勤務地モーダルでの検索処理
  const onClickLocationModalSearchButton = useCallback(
    (selectedLocation: {
      areaId: string[];
      prefectureId: string[];
      cityId: string[];
      wardId: string[];
    }) => {
      moveToSearchResultPage(
        { ...selectedSearchCondition, ...selectedLocation },
        SEARCH_TYPE.LOCATION_MODAL,
        loginStatus,
        oldestDayWdtno
      );
    },
    [loginStatus, oldestDayWdtno, selectedSearchCondition]
  );

  // 路線駅モーダルでの検索処理
  const onClickRouteStationModalSearchButton = useCallback(
    (selectedRouteStation: { routeId: string[]; stationId: string[] }) => {
      moveToSearchResultPage(
        { ...selectedSearchCondition, ...selectedRouteStation },
        SEARCH_TYPE.ROUTE_MODAL,
        loginStatus,
        oldestDayWdtno
      );
    },
    [loginStatus, oldestDayWdtno, selectedSearchCondition]
  );

  // 業種モーダルでの検索処理
  const onClickIndustryModalSearchButton = useCallback(
    (selectedIndustry: { industryLId: string[]; industrySId: string[] }) => {
      moveToSearchResultPage(
        {
          ...selectedSearchCondition,
          ...selectedIndustry,
        },
        SEARCH_TYPE.INDUSTRY_MODAL,
        loginStatus,
        oldestDayWdtno
      );
    },
    [loginStatus, oldestDayWdtno, selectedSearchCondition]
  );

  return {
    onClickSearchButton,
    onClickSearchFloatButton,
    onClickOccupationModalSearchButton,
    onClickLocationModalSearchButton,
    onClickRouteStationModalSearchButton,
    onClickIndustryModalSearchButton,
  };
};
